import { gsap } from "gsap";
import { inview } from '../../lib/inview';

export function dot(page) {

	let size = Math.max(page.w / 4.5, page.h / 2.5);

	let tl = [];

	const dotAll = document.getElementById("circle");
	let dots = Array.from(document.querySelectorAll("#circle circle"));
	let dotsNum = dots.length;
	let dotCount = 0;
	let dot;
	let delayTime;

	let maxRandomDealy = 0.1;
	let minRandomDelay = 0;

	dots = arrayShuffle(dots);

	for (var i = 0; i < dots.length; i++) {
		dot = dots[i];
		//console.log(dot.data("id"));

		delayTime = Math.random() * (maxRandomDealy - minRandomDelay) + minRandomDelay;
		delayTime = delayTime + 0.02;

		//tl[i] = gsap.timeline({repeat: -1, yoyo:true});
		tl[i] = gsap.timeline();
		tl[i].add(gsap.to(dot,
			{
				r: size,
				duration: 2.0,
				ease: "power2.in",
				delay: delayTime,
				onComplete: countEnd
			}
		));
	}

/*
	gsap.to(document.querySelectorAll(".serviceBox .ttl"),
		{
			color: "#ffffff",
			duration: 2.0,
			delay: 0.3
		}
	)

	gsap.to(document.querySelectorAll(".serviceBox .desp"),
		{
			color: "#ffffff",
			duration: 2.0,
			delay: 0.6
		}
	)
*/

	function countEnd() {
		dotCount++;
		//console.log("end");
		//console.log(dotCount);

		if (dotCount == dotsNum) {
			//console.log("dotEnd");
			window.dispatchEvent(new Event('resize'))
		}
	}

	const circle = document.querySelector(".serviceVisual");

	inview(document.getElementById('region'), (direction) => {
		circle.classList.toggle("active", direction == "down");
	});

	const regionArr = Array.from(document.querySelectorAll(".regionBox li"));
	//console.log(regionArr);
	let regionDelay = 50;

	let timeLine = [];

	inview(document.getElementById('regionBox'), (direction) => {
		if (direction == "down") {
			circle.classList.add("active");

			for (var i = 0; i < regionArr.length; i++) {
				let eachJob = regionArr[i];

				timeLine[i] = setTimeout(function () {
					eachJob.classList.add("active");
				}, regionDelay * i);
			}
		} else {
			for (var i = 0; i < regionArr.length; i++) {
				let eachJob = regionArr[i];

				clearTimeout(timeLine[i]);
				eachJob.classList.remove("active");
			}
		}
	}, '60%');


	function arrayShuffle(array) {
		for (let i = (array.length - 1); 0 < i; i--) {

			// 0〜(i+1)の範囲で値を取得
			let r = Math.floor(Math.random() * (i + 1));

			// 要素の並び替えを実行
			let tmp = array[i];
			array[i] = array[r];
			array[r] = tmp;
		}
		return array;
	}
}
